import { API_BASE } from '../../apiBase';
// ─────────────────────────────────────────────────────────────────────────────
// CMS frontend adapter — Quality Measures come from CMS public data (by CCN),
// not PointClickCare. Calls the Render backend relay
// (GET /api/cms/quality-measures/:ccn), which queries the CMS Nursing-Home QM
// datasets. Returns one row of measures for the facility, or null so the report
// falls back to its "comes from CMS" note (demo org uses mock instead).
//
// QM is keyed by a real CMS CCN. The PCC sandbox facilities are PCC facIds
// (12/22/44) with no CCN, so this returns empty for them and real rows only for
// a facility whose scope value is an actual CMS certification number.
// ─────────────────────────────────────────────────────────────────────────────

function cmsBase() {
  if (typeof window !== "undefined" && window.CMS_PROXY_URL) return window.CMS_PROXY_URL;
  // Mirror the PCC proxy host; swap the /api/pcc path for /api/cms.
  if (typeof window !== "undefined" && window.PCC_PROXY_URL) {
    return String(window.PCC_PROXY_URL).replace(/\/api\/pcc\/?$/, "/api/cms");
  }
  return `${API_BASE}/api/cms`;
}

// A CMS CCN is 6 digits. Guard so we never call the relay with a PCC facId.
function looksLikeCcn(v) {
  return /^\d{6}$/.test(String(v || "").trim());
}

// Returns [row] on success (one facility's measures), or null to fall back.
export async function getCmsQualityMeasures(facilityCcn) {
  if (!looksLikeCcn(facilityCcn)) return null; // "ALL" or a PCC facId — no rollup
  try {
    const res = await fetch(`${cmsBase()}/quality-measures/${encodeURIComponent(facilityCcn)}`, {
      headers: { Accept: "application/json" },
    });
    if (!res.ok) return null;
    const data = await res.json().catch(() => null);
    const rows = data && Array.isArray(data.rows) ? data.rows : null;
    if (!rows || !rows.length) return null;
    // Only surface the row if at least one measure resolved — an all-null row
    // (dataset unreachable / CCN not in the QM dataset) should show the note.
    const hasAny = rows.some((r) => Object.entries(r).some(([k, v]) => k !== "facilityCcn" && v != null));
    return hasAny ? rows : null;
  } catch {
    return null;
  }
}
